import React from 'react'
import injectStyles from 'react-jss'
import classNames from 'classnames'

import DeleteIcon from '../../../../../Assets/Images/icons/delete'

import styles from '../styles'
import StyledIconButton from '../../../../Form/StyledIconButton'
import { Input } from '../../../../Form/Input/index'

const PitchQuestionItemView = ({
  onAddOption,
  onDeleteQuestion,
  description,
  type,
  onSetCorrectAnswer,
  classes,
  onQuestionChange,
  canBeDeleted,
  isDisabled,
  children,
}) => {
  const {
    wrapper,
    columnsContainer,
    titleWrapper,
    itemsContainer,
    input,
    button,
    buttonsContainer,
    buttonAdd,
    buttonDelete,
    disabledBlock,
    hint,
  } = classes

  return (
    <div className={wrapper}>
      {isDisabled && (
        <div className={hint}>Old questions cannot be edited, only deleted</div>
      )}
      <div
        className={classNames(columnsContainer, {
          [disabledBlock]: isDisabled,
        })}
      >
        <header className={titleWrapper}>
          <Input
            className={input}
            onChange={e => onQuestionChange(e.target.value)}
            defaultValue={description}
            type="text"
            placeholder="Question"
          />
        </header>
        <section className={itemsContainer}>{children}</section>
      </div>
      <div className={buttonsContainer}>
        <StyledIconButton
          className={classNames(button, buttonDelete)}
          onClick={onDeleteQuestion}
        >
          <DeleteIcon width={10} height={10} fill="white" />
        </StyledIconButton>
        <StyledIconButton
          className={classNames(button, buttonAdd, {
            [disabledBlock]: isDisabled,
          })}
          onClick={onAddOption}
        >
          +
        </StyledIconButton>
      </div>
    </div>
  )
}

export default injectStyles(styles)(PitchQuestionItemView)



// WEBPACK FOOTER //
// ./src/Components/PitchQuestionsForm/blocks/PitchQuestionItem/component/PitchQuestionItemView.js